module.exports = __webpack_public_path__ + "img/bg_chess_03.1be7894e.jpg";